import * as React from 'react';
import { isSelectKey } from '../../../common/keyCodes';
import { st, classes } from './Tab.st.css';
import { TABS_DATA_KEYS } from '../dataHooks';
import { Component } from '../GenericComponent';
import { TabType, TabProps } from './types';

export const Tab = React.forwardRef<HTMLLIElement, TabProps>((props, ref) => {
  const {
    index,
    item,
    onClick,
    isActive,
    isFocusable,
    indicateActive,
    className,
    isTabDiv,
  } = props;

  let tabType: TabType = 'Link';
  if (isTabDiv) {
    tabType = 'Div';
  } else if (item.href) {
    tabType = 'Anchor';
  }

  const { title, href, target, rel, prefix, suffix } = item;
  const onSelectTab = (e: React.BaseSyntheticEvent) => {
    onClick(index, e);
  };
  const onKeyDown = (e: React.KeyboardEvent<HTMLLIElement>) => {
    if (isSelectKey(e)) {
      onSelectTab(e);
      e.preventDefault();
      return false;
    }

    return undefined;
  };

  const dataAttributes = {
    [TABS_DATA_KEYS.tabIndex]: index,
    [TABS_DATA_KEYS.tabIsActive]: isActive,
  };

  const renderTitle = () => {
    const Title = () => (
      <div className={classes.tabContentWrapper}>
        {prefix ? <span className={classes.prefix}>{prefix}</span> : null}
        <span>{title}</span>
        {suffix ? <span className={classes.suffix}>{suffix}</span> : null}
      </div>
    );
    switch (tabType) {
      case 'Anchor':
        return (
          <a className="has-custom-focus" href={href} target={target} rel={rel}>
            <Title />
          </a>
        );
      case 'Link':
        return (
          <span role="link">
            <Title />
          </span>
        );
      case 'Div':
      default:
        return <Title />;
    }
  };

  return (
    <Component
      ref={ref}
      className={st(
        classes.root,
        { isActive, indicateActive, hasAnchor: tabType === 'Anchor' },
        className,
        'has-custom-focus',
      )}
      {...dataAttributes}
      data-hook={props['data-hook']}
      key={`${title}-${index}`}
      id={item.id}
      onClick={onSelectTab}
      onKeyDown={onKeyDown}
      tabIndex={tabType === 'Link' || isFocusable ? 0 : -1}
      {...(tabType !== 'Div' && {
        'aria-current': isActive,
        renderAs: 'li',
      })}
      {...(tabType === 'Div' && {
        role: 'tab',
        renderAs: 'div',
        'aria-selected': isActive,
        'aria-controls': `${item.id}-tab`,
      })}
    >
      {renderTitle()}
    </Component>
  );
});
